
 import React, { useState, useEffect, useContext } from "react";
 import tmdbApi from "../api/tmdbApi";
 import { useNavigate, Link } from "react-router-dom";
 import Modal from 'react-bootstrap/Modal';
 import SweetAlert from 'react-bootstrap-sweetalert';
 import Loader from "../components/loader";
 import { contentContext } from "../context/contentContext";
 import moment from "moment";
 import * as Config from "../constants/Config";
 
 import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";
 
 let { lambda, country, appname } = window.app;
 
 
 const Request = () => {
     const [pwd, setPwd] = useState('');
     const [email, setEmail] = useState("");
     const [error, setError] = useState('');
     const [success, setSuccess] = useState(false);
     const [config, setConfig] = useState({});
     const navigate = useNavigate();
     const [image, setImg] = useState('');
     const [showSessionPopup, setShowSessionPopup] = useState(false);
     const [BtnLoader, setBtnLoader] = useState('');
 
     const { userData, setUserData, activeMenuObj, setActiveMenuObj,clientInfo,  isRefreshed, setIsRefreshed, GetUserDataContext,activeMenuId, setActiveMenuId } = useContext(contentContext)
 
     // useEffect(() => {
     //     websitedefaults();
     // }, []);
     // const websitedefaults = async () => {
     //     try {
     //         console.log(tmdbApi);
     //         const response = await tmdbApi.websitedefaults();
 
     //         console.log(response);
     //     } catch {
     //         console.log("error");
     //     }
     // };
     useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    
    
    }, [window.site]);
 
     useEffect(() => {
         if ((localStorage.getItem("userId"))) {
             GetUserDataSignIn();
         }
     }, []);
 
    //  const handleKeypress = (e) => {
    //      //it triggers by pressing the enter key
 
    //      if ((e.key === "Enter")) {
    //          setTimeout(function () {
    //              handleSignIn();
    //              console.log("called");
    //          }, 1000);
    //      }
    //  };
 
    //  const handleSignIn = (e) => {
    //      console.log("called1");
    //      if (email === "" && pwd === "") {
    //          setError("Please enter Email and Password");
    //          setTimeout(function () { setError("") }, 3000);
    //      }
    //      else if (email === "") {
    //          setError("Please enter Email");
    //          setTimeout(function () { setError("") }, 3000);
    //      }
    //      else if (pwd === "") {
    //          setError("Please enter Password");
    //          setTimeout(function () { setError("") }, 3000);
    //      }
    //      if (email && pwd) {
    //          setBtnLoader("loginpwd")
    //          loginPwd();
    //      }
    //  }
 
     const loginPwd = async () => {
         try {
             
             const response = await tmdbApi.signin({
                 "emailId": email,
                 "password": pwd,
                 "useragent": JSON.parse(localStorage.getItem("loc"))
             });
             console.log(response);
             if (response?.statusCode===200 && response?.result === "Invalid email or password") {
                 setError(response?.result);
                 setTimeout(function () { setError("") }, 3000);
                 setBtnLoader("")
             } else if (response?.result === "Session Already Exists") {
                 // signoutsession()
                 setShowSessionPopup(true)
                 setBtnLoader("")
             }else if(response?.statusCode===200 && localStorage.getItem("check") ){
                 localStorage.setItem("token", response?.result.token.token);
                 localStorage.setItem("userId", response?.result.userid);
                 GetUserDataSignIn();
                 localStorage.setItem("loginTime",moment().format('DD-MMM-YYYY HH:mm:ss'))
                 window.location.replace("/viewcontent/" + localStorage.getItem("check"));
                 localStorage.removeItem("check");
 
             } else {
                 localStorage.setItem("token", response?.result.token.token);
                 localStorage.setItem("userId", response?.result.userid);
                 GetUserDataSignIn();
                 localStorage.setItem("loginTime",moment().format('DD-MMM-YYYY HH:mm:ss'))
                 // navigate("/usermanagement");
             }
            
 
         } catch {
             console.log("error");
             setBtnLoader("")
             setError("Invalid email or password");
             setTimeout(function () { setError("") }, 3000);
         }
     };
     // console.log('userDatauserDatauserData', userData)
     const GetUserDataSignIn = async () => {
         try {
 
             const response = await tmdbApi.getUserData({});
 
             if (response?.statusCode === 200) {
 
                 setUserData(response?.result?.[0]);
                 localStorage.setItem("ClientName", response?.result?.[0]?.name)
                 localStorage.setItem("ClientType", response?.result?.[0]?.type)
                 let userArr = response?.result?.[0]?.permissions
                 const EMAILID = response?.result?.[0]?.emailid
                 console.log('user email',EMAILID)
                 window.clarity("set", "orasi_user_email", EMAILID)
                 // Clarity.addTag('Orasi User Email', EMAILID);
                 const obj = userArr.reduce((acc, item) => {
                     if (item.submenus) acc[item.menu] = false;
                     return acc;
                 }, {});
                 // console.log('objjjjjjjj--->',obj)
 
                 if(!(localStorage.getItem("check"))){
                 let k = response?.result?.[0]
 
                 let permissionList = response && response?.result && response?.result?.[0] && response?.result?.[0]?.permissions
                 let filterdList = permissionList.filter((item) => item.display===true)
                 const data= filterdList?.filter((value)=>value?.menu==="Dashboard")
                 let id = data && data[0] && data[0].menu.split(" ").join("").toLowerCase()
 
                 navigate("/" + id);
                 navigate("/users");
                 
 
                 setActiveMenuId(data && data[0] && data[0].menuid)
                 console.log("activeMenuid------->",data)
                 }
 
                 // setActiveMenuObj(obj)
                 setBtnLoader("")
                 // console.log('response?.result?.[0] kkkkkkkkkk', response?.result?.[0])
             }
         } catch {
             setBtnLoader("")
             console.log("error");
         }
     };
 
    //  const forgotPassword = async () => {
    //      try {
    //          setBtnLoader("forgotpwd")
    //          const response = await tmdbApi.ForgotPassword({
    //              "emailid": email
    //          });
    //          console.log(response);
    //          if (response?.statusCode===200 && response?.result === "mail sent successfully") {
    //              setSuccess(true);
    //          } else if(response?.statusCode===200 && response?.result === "Email does not exists"){
    //              setError("Email Does Not Exists . Please Enter Valid Email");
    //              setTimeout(function () { setError("") }, 3000);
    //          }else {
    //              setError("Please Enter Email Id");
    //              setTimeout(function () { setError("") }, 3000);
    //          }
    //          setBtnLoader("")
    //      } catch {
    //          console.log("error");
    //          setBtnLoader("")
    //          setError("Please enter email id");
    //          setTimeout(function () { setError("") }, 3000);
    //      }
    //  };
 
 
    //  const handleForgot = (e) => {
    //      if(BtnLoader===""){
    //      forgotPassword();
    //      }
    //  }
 
    //  function onConfirm() {
    //      setSuccess(false);
    //  };
 
    //  const handleShowSessionPopup = () => {
    //      setShowSessionPopup(true)
    //  }
     const onCancel = () => {
         setShowSessionPopup(false)
         setBtnLoader("")
     }
     const signoutsession = async () => {
         try {
             setBtnLoader("sessionLoad")
             const response = await tmdbApi.SignOutUser({ emailId: email });
             console.log(response);
             if (response?.result==="Success") {
                 loginPwd()
             } else {
                 setError("Invalid Details");
                 setBtnLoader("")
             }
         } catch {
             setBtnLoader("")
             console.log("error");
         }
     }
 
    //  const handleMessage = (e) => {
    //      setError("");
    //  }
 
const handleBack=()=>{
    navigate("/signin")
    localStorage.removeItem("clientid");
}



return (
    <>
        <Modal className="access-denied" show={showSessionPopup} id="access-denied-modal">
            <div className="modal-body enquiry-form">
                <div className="container">
                    <button
                        className="close-btn"
                        onClick={e => onCancel()}
                        id="close-session-popup-btn"
                    >
                        <span className="material-icons">close</span>
                    </button>
                    <span className="material-icons access-denied-icon" id="access-denied-icon">
                        web_asset_off
                    </span>
                    <h3 id="multiple-sessions-heading">Multiple Sessions Found</h3>
                    <p id="multiple-sessions-description">
                        Another session is running in another browser. Do you want to terminate that session?
                    </p>
                    <div className="popup-footer">
                        <button
                            className="fill_btn yellow-gradient"
                            data-bs-toggle="modal"
                            data-bs-target="#recommendModal"
                            onClick={e => signoutsession()}
                            id="yes-button"
                        >
                            {BtnLoader==="sessionLoad" ? (
                                <img
                                    src={`${image}${appname}/images/web/rotate_right.svg`}
                                    className="loading-icon"
                                    alt="loading"
                                    id="loading-icon"
                                />
                            ) : null}
                            Yes
                        </button>
                        <button
                            className="fill_btn"
                            data-bs-toggle="modal"
                            data-bs-target="#recommendModal"
                            onClick={e => onCancel()}
                            id="no-button"
                        >
                            No
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
  
<div className="container you-almost-there" id="you-almost-there-container">
            <div className="signin-wrapper" id="signin-wrapper">
                <img
                    src={`${image}${appname}/images/web/logo-dark.png`}
                    className="logo"
                    alt="logo"
                    id="logo-img"
                />
                <div className="row almost-section" id="almost-section">
                    <div className="col-md-6" id="left-column">
                        <img
                            src={`${image}${appname}/images/web/Almost-there-graphic.svg`}
                            className="img-size"
                            alt="group-graphic"
                            id="group-img"
                        />
                    </div>
                    {/* <div className="col-md-6" id="right-column">
                        <h1 className="bold-heading" id="almost-there-heading">You’re almost there!</h1>
                        <p className="mt-4 mb-2 discription-text" id="request-received-text">
                            Your request has been received and is being reviewed by our support staff.
                        </p>
                        {userData?.type==="email"? <p className="mb-3 discription-text" id="notification-text">
                            You will be notified through Email, once approved
                        </p>: <p className="mb-3 discription-text" id="notification-text" style={{ fontWeight: 'bold' }}>
                        To complete the process,
                       A Verification code has been sent to the registered Email ID
                        </p>}
                       
                        <button
                            className="fill-btn"
                            onClick={handleBack}
                            id="back-to-home-btn"
                        >
                            Back to Home
                        </button>
                    </div> */}
                    <div className="col-md-6" id="right-column">
                        <h1 className="bold-heading mb-1" id="almost-there-heading">You’re almost there!</h1>
                        <div className="d-flex align-items-center mb-3">
                        <span><img src={ `${image}${appname}/images/web/youre-almost-checkin.svg`}  alt="Verified" style={{ width: '16px', marginRight: '6px', verticalAlign: 'middle', marginTop: '23px' }}  /></span>
                        <p className="mt-4 mb-0 discription-text" id="request-received-text">Your Contact Number has been verified </p>
                        </div>
                        <div className="d-flex align-items-center mb-3">
                        <span><img src={ userData?.type==="email"?` ${image}${appname}/images/web/youre-almost-checkin.svg` : ` ${image}${appname}/images/web/youre-almost-waiting.svg` } alt="Verified" style={{ width: '16px', marginRight: '6px', verticalAlign: 'middle', marginBottom: '23px' }}  /></span>
                        <p className="mb-0 discription-text" id="request-received-text"> Please check your email and <br />complete the email verification process </p>
                        </div>
                        <div className="d-flex align-items-center mb-3">
                        <span><img src={ ` ${image}${appname}/images/web/youre-almost-waiting.svg`} alt="Verified" style={{ width: '16px', marginRight: '6px', verticalAlign: 'middle', marginBottom: '39px' }}  /></span>
                        <p className="discription-text" id="request-received-text"> Our support staff would review and complete the  <br /> onboarding process. </p>
                        </div>
                        <button
                            className="fill-btn mt-3"
                            onClick={handleBack}
                            id="back-to-home-btn"
                        >
                            Back to Home
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <footer className="login_footer" id="login-footer">
            <div className="container-fluid">
                <p className="footer-para" id="footer-para">
                © 2025 SpotSaver. All rights reserved. 
                </p>
            </div>
        </footer>
       
    </>
);

 };
 
 export default Request;
 